(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('globalErrorInterceptor', globalErrorInterceptor);

    globalErrorInterceptor.$inject = ['$q', '$injector', 'RequestService'];

    function globalErrorInterceptor($q, $injector, RequestService) {

        var service = {
            request: request,
            responseError: responseError
        };

        return service;

        // Configure the action to execute when a request starts
        function request(config) {
            // If the request is of type get and the request doesn't have a timeout configured yet
            if ((config.method == 'GET' || config.cancelable) && !config.timeout && !config.ignoreCancel) {
                // Create a deferred object
                var deferred = $q.defer();
                // Add the promise of the deferred to the timeout property of the request
                config.timeout = deferred.promise;
                // Add a reference to the deferred to the request to resolve the promise when needed
                config.cancel = deferred;
            }
            // Return the modified config to the promise chain
            return config;
        }

        // Configure the action to execute when the request finishes with error
        function responseError(response) {

            // List of errors to be intercepted
            var errors = ['500', '-1', '412', '403'];
            // Error status
            var status = response.status.toString();
            // Services injected through $injector to avoid circular dependency
            var $state = $injector.get('$state');
            var UserData = $injector.get('UserData');

            // If any of the errors on the list occur
            if (errors.indexOf(status) > -1) {

                // If the user is trying to access any private page while not authenticated, send to login
                if (!UserData.isAuthenticated && $state.current.name != 'login') {

                    $state.go('login');

                } else {

                    // Inject the AlertModalService and calls it's error method to open the error modal
                    if (!(response.data && response.data.ignore)) {
                        var AlertModalService = $injector.get('AlertModalService');
                        AlertModalService.error(response, 'default', 'global');
                    }

                    // Add the intercepted property to the response, so intercepted errors cannot be triggered again
                    response.intercepted = true;

                }

            }

            // Return a rejection to the promise chain with the modified response as reason
            return $q.reject(response);

        }

    }
})();
